import * as Tabs from '@radix-ui/react-tabs'
import styles from './RadixTabs.module.css'

type Tab = {
    label: string
    value: string
    content: any
}

type RadixTabsProps = {
    tabs: Tab[]
}

export const RadixTabs = ({ tabs }: RadixTabsProps) => (
    <Tabs.Root defaultValue={tabs[0]?.value ?? null}>
        <Tabs.List
            aria-label="tabs example"
            className="flex-shrink-0 flex border border-gray-100 bg-white"
        >
            {tabs.map((i, idx) => (
                <Tabs.Trigger key={idx} className={styles.Tab} value={i.value}>
                    {i.label}
                </Tabs.Trigger>
            ))}
        </Tabs.List>
        {tabs.map((i, idx) => (
            <Tabs.Content key={idx} value={i.value}>
                {i.content}
            </Tabs.Content>
        ))}
    </Tabs.Root>
)
